(() => {
  const config = document.getElementById('astrosage-review-widget-config');
  if (!config) return;
  let started = false;
  const events = ['pointerdown', 'keydown', 'scroll'];
  function start() {
    if (started) return;
    started = true;
    events.forEach(event => window.removeEventListener(event, start));
    if (document.getElementById('merchantWidgetScript')) return;
    const script = document.createElement('script');
    script.id = 'merchantWidgetScript';
    script.src = 'https://www.gstatic.com/shopping/merchant/merchantwidget.js';
    script.async = true;
    script.addEventListener('load', () => {
      if (!window.merchantwidget) return;
      window.merchantwidget.start(JSON.parse(config.textContent));
      const labelFrame = () => {
        const frame = document.getElementById('merchantwidgetiframe');
        if (!frame) return false;
        frame.title = 'Google Reviews';
        return true;
      };
      if (!labelFrame()) {
        const observer = new MutationObserver(() => { if (labelFrame()) observer.disconnect(); });
        observer.observe(document.body, {childList: true, subtree: true});
        window.setTimeout(() => observer.disconnect(), 30000);
      }
    }, {once: true});
    document.head.appendChild(script);
  }
  if (config.dataset.defer === 'true') {
    events.forEach(event => window.addEventListener(event, start, {once: true, passive: true}));
  } else start();
})();
